<template>
  <div class="p1-search-1 b">
    <div class="blk-main content">
      <div class="blk-md blk">
        <div class="p1-search-1-inp fr">
          <input
            class="p1-search-1-inp1"
            name="q"
            placeholder="请输入关键字"
            type="text"
            v-model="searchText"
          />
          <span class="p1-search-1-inp2" @click="toSearchPage"></span>
        </div>
        <p>
          热门关键词：
          <router-link
            :to="{ path: '/search', query: { q: item.name } }"
            v-for="(item, index) in keywordlist"
            :key="index"
            >{{ item.name }}</router-link
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keywordlist: [],
      searchText: ""
    };
  },
  mounted() {
    this.getKeyword_list();
  },
  methods: {
    toSearchPage: function() {
      if (this.searchText == "") {
        this.$message({
          message: "请输入想要搜索的内容",
          type: "warning"
        });
        return false;
      }
      this.$router.push({ path: "/search", query: { q: this.searchText } });
    },
    getKeyword_list: function() {
      this.$post("/Keyword/keyword_list", {}).then(response => {
        this.keywordlist = response.data || [];
      });
    }
  }
};
</script>

<style lang="less">
.ty-banner-1 {
  overflow: hidden;
  line-height: 0;
  text-align: center;
}
.p1-search-1 {
  background: rgba(242, 242, 242, 1);
  height: 82px;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  overflow: hidden;
  font-size: 15px;
  p {
    color: rgba(51, 51, 51, 1);
    line-height: 82px;
    a {
      color: rgba(51, 51, 51, 1);
      display: inline-block;
      margin-right: 15px;
    }
  }
}
.p1-search-1-inp {
  width: 294px;
  height: 48px;
  background-color: rgba(255, 255, 255, 1);
  border: solid 1px rgba(224, 224, 224, 1);
  padding-left: 10px;
  margin-top: 18px;
  input {
    border: 0;
  }
  .p1-search-1-inp1 {
    width: 243px;
    height: 30px;
    line-height: 30px;
    color: #a9a9a9;
    float: left;
    margin-top: 9px;
  }
  .p1-search-1-inp2 {
    width: 50px;
    height: 48px;
    border-left: solid 1px rgba(224, 224, 224, 1);
    background: url(~@img/search-icon.png) no-repeat center center;
    background-size: 25px 25px;
    float: right;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/searchBar.vue